import { MAIN_QUESTS_GROUP, appConfig } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const zipClashQuestsLvl1: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow on Immutable Play",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "bc7cfbe8-cf31-4dc3-b202-3adbf0873dd0-wishlist-added",
    ruleId: "bc7cfbe8-cf31-4dc3-b202-3adbf0873dd0-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch trailer",
    caption: "Learn about what's coming up",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/zip-clash/ZipClashTrailer.mp4`,
    videoMimeType: "video/mp4",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "bc7cfbe8-cf31-4dc3-b202-3adbf0873dd0-trailer-event",
    ruleId: "bc7cfbe8-cf31-4dc3-b202-3adbf0873dd0-trailer",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow on X",
    caption: "Don't miss a tweet",
    linkUrl: "https://x.com/Zip_Clash",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "bc7cfbe8-cf31-4dc3-b202-3adbf0873dd0-twitter-event",
    ruleId: "bc7cfbe8-cf31-4dc3-b202-3adbf0873dd0-twitter",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord channel",
    caption: "Join now to get a custom role!",
    linkUrl: "https://discord.com/invite/zipclash",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "bc7cfbe8-cf31-4dc3-b202-3adbf0873dd0-discord-event",
    ruleId: "bc7cfbe8-cf31-4dc3-b202-3adbf0873dd0-discord",
  },
  {
    type: "link",
    key: "telegram-v2",
    icon: "Telegram",
    label: "Join Telegram channel",
    caption: "Join our massively growing community",
    linkUrl: "https://t.me/ZipClashCommunity",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "bc7cfbe8-cf31-4dc3-b202-3adbf0873dd0-zipclash-telegram-validation-completed",
    ruleId: "zipclash-telegram-validation",
  },
];

const zipClashQuestsLvl2: Quest[] = [
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Download the game",
    caption: "Get ready to play",
    linkUrl:
      "https://play.google.com/store/apps/details?id=com.aredstudio.zipclash.cook.farm.earn&pli=1",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "bc7cfbe8-cf31-4dc3-b202-3adbf0873dd0-website-download-game-event",
    ruleId: "bc7cfbe8-cf31-4dc3-b202-3adbf0873dd0-website-download-game",
    waitTimeInHrs: 24,
  },
  {
    type: "custom",
    key: "bonus",
    icon: "ImxRewards",
    label: "Bonus reward",
    caption: "Extra Gems for completing all quests",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "bc7cfbe8-cf31-4dc3-b202-3adbf0873dd0-onboarding-bonus-event",
    ruleId: "bc7cfbe8-cf31-4dc3-b202-3adbf0873dd0-onboarding-bonus",
  },
];

const zipClashGameplayQuests: Quest[] = [
  {
    type: "custom",
    key: "in-game",
    icon: "ImxRewards",
    label: "Hold the NFT",
    caption: "Earn 10 Gems",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "bc7cfbe8-cf31-4dc3-b202-3adbf0873dd0-zipclash-questing-api-hold-nft-completed",
    ruleId: "zipclash-questing-api-hold-nft",
  },
  {
    type: "custom",
    key: "in-game",
    icon: "ImxRewards",
    label: "Complete the testing level",
    caption: "Earn 50 Gems",
    increase: 50,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "bc7cfbe8-cf31-4dc3-b202-3adbf0873dd0-zipclash-questing-api-testing-completed",
    ruleId: "zipclash-questing-api-testing",
  },
  {
    type: "custom",
    key: "in-game",
    icon: "ImxRewards",
    label: "Complete the tutorial",
    caption: "Earn 25 Gems",
    increase: 25,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "bc7cfbe8-cf31-4dc3-b202-3adbf0873dd0-zipclash-questing-api-tutorial-completed",
    ruleId: "zipclash-questing-api-tutorial",
  },
  {
    type: "custom",
    key: "in-game",
    icon: "ImxRewards",
    label: "Get to kitchen level 5",
    caption: "Earn 100 Gems",
    increase: 50,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "bc7cfbe8-cf31-4dc3-b202-3adbf0873dd0-zipclash-questing-api-kitchen-level5-completed",
    ruleId: "zipclash-questing-api-kitchen-level5",
  },
];

const zipClashSocialEngagementQuests: Quest[] = [
  {
    type: "custom",
    key: "social-engagement",
    icon: "SupportChat",
    label: "Post a message and engage in the Telegram channel daily",
    caption: "Earn gems everyday",
    increase: 10,
    badgeIcon: "ImxRewards",
    recurring: true,
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "bc7cfbe8-cf31-4dc3-b202-3adbf0873dd0-zipclash-telegram-social-engagement-completed",
    ruleId: "zipclash-telegram-social-engagement",
  },
];

export const zipClashQuests: QuestGroup[] = [
  {
    key: "level-1",
    header: {
      image: "",
      title: "Learn and connect",
      description: "Level 1 Supporter",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +30 <icon> Gems",
    totalGemsGranted: 30,
    hideOnCompletion: true,
    lockedUntilPrevious: false,
    quests: zipClashQuestsLvl1,
    introModal: {
      title: "You are on your way to Level 1",
      description:
        "Thanks for following <name>. Keep showing your support and earn better perks while doing it.",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z612cpbqstJ9-jZk_ZC_level1.png?auto=format,compress",
    },
  },
  {
    key: "level-2",
    header: {
      image: "",
      title: "Dive deeper",
      description: "Level 2 Believer",
    },
    nextQuest: {
      url: "/games/champignons-of-arborethia/",
      title: "Thanks for getting involved",
      label: "Want more? Check out Champz",
      caption: "Earn additional rewards and support more games",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +20 <icon> Gems",
    totalGemsGranted: 20,
    hideOnCompletion: false,
    lockedUntilPrevious: false,
    quests: zipClashQuestsLvl2,
    introModal: {
      title: "Level 2, here you go",
      description:
        "People like you are making Zip Clash a better and bigger game. Let's keep at it.",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z6w64pbqstJ9-goo_ZC_level2.png?auto=format,compress",
    },
    exitModal: {
      title: "That's all folks",
      description:
        "Level 2 Believer achieved. Bigger and better quests are on the horizon!",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z612rZbqstJ9-jZs_Cat_Jump.png?auto=format,compress",
    },
  },
  {
    key: "social-engagement",
    header: {
      image: "",
      description: "",
      title: "Social Engagement",
    },
    totalGemsGranted: 10,
    quests: zipClashSocialEngagementQuests,
    hideOnCompletion: false,
    lockedUntilPrevious: false,
    questGroup: MAIN_QUESTS_GROUP,
  },
];

if (appConfig.ENVIRONMENT !== "production") {
  zipClashQuests.unshift({
    key: "play",
    header: {
      image: "",
      title: "Play and earn additional rewards",
      description: "",
    },
    totalGemsGranted: 95,
    hideOnCompletion: false,
    lockedUntilPrevious: false,
    quests: zipClashGameplayQuests,
  });
}
